<main>
    <section class="flex justify-between items-center mb-3">
        <h1 class="text-2xl font-bold text-gray-800">Familias</h1>
        <add-button label="Nueva familia" (onClick)="openEditForm()"></add-button>
    </section>

    <sau-table #sauTable [url]="url" contentList="list" contentTotal="count" [sizeInitialPage]="1" pageParamName="page" limitParamName="limit"
        contentTotal="total" [headers]="headers" (deleteEvent)="openDeleteForm($event)"
        (editEvent)="openEditForm($event)"></sau-table>

</main>
